// extracted by mini-css-extract-plugin
export default {"main":"styles_main__ig07K","main2":"styles_main2__aQoSx","arrow":"styles_arrow__9spcb"};